import store from '../../store';
import { UI_FIXED_SCROLLBAR, UI_UNFIXED_SCROLLBAR } from '../../store/events';
import getScrollbarWidth from '../../utils/getScrollbarWidth';

export default function (context) {
	if (!window.UpButton)
		return;

	setTimeout(() => {
		const container = document.getElementById('back-to-top-container');
		if (container)
		{
			const upButton = new UpButton({ 
				container,
				fixingBreakpoint: store.state.ui.breakpoints.md
			})
	
			store.subscribe(UI_FIXED_SCROLLBAR, () => {
				upButton.button.style.marginRight = getScrollbarWidth() + 'px';
			});
	
			store.subscribe(UI_UNFIXED_SCROLLBAR, () => {
				upButton.button.style.removeProperty('margin-right');
			});
		}
	}, 2000);
};
